// extracted by mini-css-extract-plugin
export default {"root":"PropertiesTable_root__X74Bm"};